import React from 'react';

export interface AboutSectionProps {
    id?: string;
    className?: string;
    children?: any;
}

export function AboutSection(props: AboutSectionProps) {
    return (
        <section id={props.id} className="section">
            <div className="container">
                <div className="columns is-vcentered is-variable is-8">
                    <div className="column">
                        <h1 className="title">
                            <span className="is-family-secondary">ABOUT</span>
                            コンテスト概要
                        </h1>
                        <p className="is-size-5 is-size-6-mobile is-margin-bottom-3">
                            ミスサークルコンテストは、日本一の大学サークル美人を決める、ミスコンテストです。<br />
                            <br />
                            2010年に初開催され、これまで、在京キー局アナウンサー、モデル、アーティスト等を輩出している、日本最大級のコンテストです。
                        </p>
                        <table className="table is-fullwidth">
                            <tbody>
                            <tr>
                                <th className="is-narrow"style={{verticalAlign: "middle"}}>主催</th>
                                <td>MISS CIRCLE CONTEST 2019 実行委員会<br />
                                    株式会社エイジ・エンタテインメント</td>
                            </tr>
                            <tr>
                                <th className="is-narrow" style={{verticalAlign: "middle"}}>企画制作</th>
                                <td><figure className="image"><img src="/images/logo_misscolle.png" /></figure></td>
                            </tr>
                            <tr>
                                <th className="is-narrow" style={{verticalAlign: "middle"}}>特別協賛</th>
                                <td><figure className="image"><img src="/images/logo_rize.png" /></figure></td>
                            </tr>
                            <tr>
                                <th className="is-narrow" style={{verticalAlign: "middle"}}>特別協力</th>
                                <td><figure className="image"><img src="/images/logo_fuji_modelpress.png" /></figure></td>
                            </tr>
                            <tr>
                                <th className="is-narrow" style={{verticalAlign: "middle"}}>協賛</th>
                                <td><figure className="image"><img src="/images/logo_showroom_mysta_watabe.png" /></figure></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="column">
                        <img className="is-rounded has-shadow" src="/images/about@2x.jpg" />
                    </div>
                </div>
            </div>
        </section>
    )
}